//872044295402594
//149201768272394
//EAAMdyZCyrMDMBQeqwKvCGIpdRX18OhMtZCTnFuzaAoWGgMkvDvmpFdfPQdK5YZAbrfAYselWUxYGqVcr1CZA8FQyB5IDwKLdc4FkYNpdoGzpUrgsCwkq0dhSgjZCPvZBEjcQdN2lX1E4fO0BL3hKSTwoBpuBbrxCEkPU76ly0yVj88f2sGbH7qKTb17ZAvklizxCwZDZD




import React from 'react';
import {  Routes, Route} from 'react-router-dom';
import Dashboard from './component/Dashboard';
import './App.css';
import {  Navigate } from 'react-router-dom';
import Login from './component/Login';
import ProtectedRoute from './component/ProtectedRoute';

//import Payments  from './component/Payments';
import Notices  from './component/Notices';
import  Residents from "./component/Residents"; 
import CommonAreas from './component/CommonAreas';
//import MyBookings from './component/common-areas/MyBookings';
import AdminBookings from './component/AdminBookings';
import MyBookings from  './component/MyBookings';
import OwnerList from "./component/OwnerList"
import PaymentForm from "./component/PaymentForm"
import Complaint from "./component/Complaint"
import ExpenseForm from "./component/ExpenseForm"
import ExpensesList from "./component/ExpensesList"
import ForgotPassword from './component/ForgotPassword';

function App() {
  //const isLoggedIn = localStorage.getItem("token"); // or session

  /* .htaccess content for redirecting all requests to index.html for React Router
  RewriteEngine On
RewriteBase /
RewriteRule ^index\.html$ - [L]
RewriteCond %{REQUEST_FILENAME} !-f
RewriteCond %{REQUEST_FILENAME} !-d
RewriteRule . /index.html [L]
  
  */
  const isLoggedIn = sessionStorage.getItem("token"); // or session
  

 return (<> 
 
      <Routes>
        {/* Default route */}
        {<Route path="/" element={isLoggedIn ? <Navigate to="/dashboard" /> : <Login />} /> }
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={ isLoggedIn ? <Dashboard /> : <Navigate to="/login" /> } />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route  path="/residents"element={isLoggedIn ? <Residents /> : <Navigate to="/login" />} />
          
          <Route  path="/notices"element={isLoggedIn ? <Notices /> : <Navigate to="/login" />} />
          <Route  path="/complaints"element={isLoggedIn ? <Complaint /> : <Navigate to="/login" />} />
          <Route  path="/users"element={isLoggedIn ? <OwnerList /> : <Navigate to="/login" />} />
          <Route  path="/common-areas/overview"element={isLoggedIn ? <CommonAreas /> : <Navigate to="/login" />} />
          <Route  path="/common-areas/checkpendingbookings"element={isLoggedIn ? <AdminBookings /> : <Navigate to="/login" /> }/>
          <Route  path="/common-areas/my-bookings"element={isLoggedIn ? <MyBookings /> : <Navigate to="/login" />} />
          <Route  path="/Payment"element={isLoggedIn ? <PaymentForm /> : <Navigate to="/login" />} />
          <Route  path="/Expenses/List"element={isLoggedIn ? <ExpensesList /> : <Navigate to="/login" />} />
          <Route  path="/Expenses/AddExpense"element={isLoggedIn ? <ExpenseForm /> : <Navigate to="/login" />} />
          <Route  path="/Expenses/EditExpense"element={isLoggedIn ? <ExpenseForm /> : <Navigate to="/login" />} />
          <Route  path="/forgot-password" element={<ForgotPassword />} />
      </Routes>
    

    
     
</>
    );

}

/*function App() {
  return (<>
    <div className="App">
      <header className="App-header">
        <h1>Soc Maintenance Application</h1>    
        <Router>
          <nav> 
            <Link to="/ownerlist">Owner List</Link> | {' '}
             <Link to="/ownerdetail"rel="noopener noreferrer"> Owner Detail </Link>
            </nav>
            <Routes>
              <Route path="/ownerlist" element={<OwnerList />} />
              <Route path="/ownerdetail" element={<OwnerDetail />} />
            </Routes>
        </Router>
      </header>     
    </div>       
    </>
  );
}*/


/*function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}*/

export default App;
